import { dispatcher } from 'dispatcher';
import { getBonusTitle } from 'js/utils/bonus.util';
import { LAYER } from 'js/components/common/PopupManager';
import { showBonusPopupAction } from 'js/components/popups/BonusPopup';
import { showCommonPopupAction } from 'js/components/common/popups/CommonPopup';
import { showGoldenChipsPopupAction } from 'js/components/popups/GoldenChipsPopup';
import { showFreeSpinsBonusPopupAction } from 'js/components/popups/FreeSpinsBonusPopup';
import { updatePeriod as updateBonusHistoryPeriod } from 'js/components/main/BonusHistory/store/actions';

import { getBonusDetails } from '../server';

const defaultBonusTitle = 'playtech.mobile.system.message.congratulations';

export const handleBonusNotificationInfo = async (
    { actionInfo, actionId, isConfirmation },
    { lang, syncClose, dispatch }
) => {
    const { dialogId, message, layer, showGamesList } = actionInfo;
    const genericShowPopupAction = isConfirmation ? showBonusPopupAction : showCommonPopupAction;
    const openTrackToken = dialogId || actionId;
    const onClose = openTrackToken
        ? () => {
            syncClose(openTrackToken);

            // todo remove dispatcher.dispatch('notification-bonus:updated') after portal implementation COR18-10496
            dispatcher.dispatch('notification-bonus:updated');
            dispatch(updateBonusHistoryPeriod());
        }
        : undefined;

    const commonActionData = {
        id: openTrackToken, // NB there are doubts whether actionId is really unique
        layer: layer || LAYER.BONUS,
        title: defaultBonusTitle,
        isModal: isConfirmation,
        dialogId,
        onClose,
        dispatch
    };

    if (dialogId && dialogId.includes('|')) {
        const [systemId, remoteBonusId] = dialogId.split('|');
        const { data: rawBonusDetails } = await getBonusDetails({ systemId, remoteBonusId });
        const bonusPopupTitle = getBonusTitle(rawBonusDetails, { lang }) || defaultBonusTitle;

        const specificPopupActionData = {
            ...commonActionData,
            syncActionsOnClose: () => syncClose(openTrackToken),
            title: bonusPopupTitle,
            message,
            isConfirmation,
            rawBonusDetails,
            showGamesList
        };

        switch (rawBonusDetails.bonus.playType) {
            case 'freespins':
                // open freeSpins popup
                return showFreeSpinsBonusPopupAction(specificPopupActionData);
            case 'goldenchips':
                // open golden chips popup
                return showGoldenChipsPopupAction(specificPopupActionData);
            default:
                // open generic bonus popup
                return genericShowPopupAction({
                    ...commonActionData,
                    title: defaultBonusTitle,
                    content: message
                });
        }
    } else {
        // open generic bonus popup
        return genericShowPopupAction({
            ...commonActionData,
            content: message
        });
    }
};
